import { render } from "./LessonCard.vue?vue&type=template&id=31b8a7bc&scoped=true"
import script from "./LessonCard.vue?vue&type=script&lang=js"
export * from "./LessonCard.vue?vue&type=script&lang=js"

import "./LessonCard.vue?vue&type=style&index=0&id=31b8a7bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b8a7bc"]])

export default __exports__